<template>
  <div id="purchase">
    <div class="page-center">
      <div class="header">
        <img class="back" src="../assets/purchase/bg.png" />
      </div>
      <!-- <div class="step">
        <p>卡特品牌，我来推广，实干成就梦想</p>
      </div> -->

      <div class="recommend-container share-price-container">
        
          <div class="recommend-body">
            <div class="left-top">
              <p>我要购机</p>
            </div>
            <div
              class="am-list-item am-input-item am-list-item-middle"
              style="margin-top: 0.64rem"
            >
              <div class="am-list-line">
                <div class="am-input-label am-input-label-5">
                  <p class="text-content">设备类型</p>
                </div>
                <div class="am-input-control">
                  <div
                    class="picker"
                    style="float: right; font-size: 3.467vw; color: #666"
                    @click="showPicker = true"
                  >
                    {{ machinery }}
                  </div>
                </div>
              </div>
            </div>
            <div class="am-list-item am-input-item am-list-item-middle">
              <div class="am-list-line">
                <div class="am-input-label am-input-label-5">
                  <p class="text-content">意向人姓名</p>
                </div>
                <div class="am-input-control">
                  <input
                    placeholder="联系人姓名"
                    class="h5numInput"
                    v-model="fillUserName"
                  />
                </div>
              </div>
            </div>
            <div class="am-list-item am-input-item am-list-item-middle">
              <div class="am-list-line">
                <div class="am-input-label am-input-label-5">
                  <p class="text-content">手机号码</p>
                </div>
                <div class="am-input-control">
                  <input
                    placeholder="请输入手机号码"
                    class="h5numInput"
                    v-model="fillPhoneNumber"
                  />
                </div>
              </div>
            </div>
            <div class="am-list-item am-input-item am-list-item-middle">
              <div class="am-list-line">
                <div class="am-input-label am-input-label-5">
                  <p class="text-content">设备使用位置</p>
                </div>
                <div class="am-input-control">
                  <div
                    class="picker"
                    style="float: right; font-size: 3.467vw; color: #666"
                    @click="showAreaPicker = true"
                  >
                    {{ area }}
                  </div>
                </div>
              </div>
            </div>
            <div class="parea-label"><p class="text-content">需求描述</p></div>
            <div class="am-list-item am-parea-item am-parea-focus">
              <div class="am-parea-control">
                <textarea
                  maxlength="100"
                  placeholder="请输入需求描述"
                  class="h5numInput"
                  style="width: 6.2rem; height: 2rem"
                  v-model="shortDesc"
                ></textarea>
              </div>
            </div>
          </div>
          <div class="tips">
            <p>提交购机信息后，将有销售人员与您联系，确认实际需要购买信息</p>
          </div>
          <div
            class="am-list-item am-parea-item am-parea-focus"
            style="padding-left: 0"
          >
            <button
              class="am-button recommend-botton bg-gradual-yellow"
              @click="submit"
            >
              <p>我要购机</p>
            </button>
          </div>
          <div class="check">
            <van-checkbox
              class="checkbox"
              v-model="checked"
              checked-color="#07c160"
              >我已阅读并同意此<span class="link" @click="openFile"
                >《隐私声明》</span
              ></van-checkbox
            >
          </div>
      </div>
    </div>
    <van-popup v-model="showPicker" round position="bottom">
      <van-picker
        show-toolbar
        :columns="columns"
        @cancel="showPicker = false"
        @confirm="onConfirm"
      />
    </van-popup>
    <van-popup v-model="showAreaPicker" round position="bottom">
      <van-picker
        show-toolbar
        :columns="areaColumns"
        @cancel="showAreaPicker = false"
        @confirm="onAreaConfirm"
      />
    </van-popup>
  </div>
</template>
<script>
import API from "../api/purchase.js";
import city from "../../static/js/area.js";
import wechatAPI from "../api/weChatOfficialAcount";
import { Toast } from "vant";
export default {
  name: "purchase",
  data() {
    return {
      fillUserName: "",
      fillPhoneNumber: "",
      machineryList: [],
      columns: [],
      showPicker: false,
      machinery: "请选择",
      productId: "",
      areaColumns: city.city,
      showAreaPicker: false,
      province: "",
      city: "",
      county: "",
      area: "选择地址",
      shortDesc: "",
      checked: false,
      code: "",
    };
  },
  created() {
    sensors.registerPage({
      platform_type: "购机意向H5",
    });
    sensors.quick("autoTrack");
    this.login();
    this.getMachineryList();
  },
  mounted() {},
  methods: {
    getMachineryList() {
      this.$axios
        .get(API.purchaseAPI.machineryList)
        .then((res) => {
          if (res.data.statusCode == 1000) {
            let machineryTitle = [];
            for (let i = 0; i < res.data.data.length; i++) {
              machineryTitle[i] = res.data.data[i].title;
            }
            this.machineryList = res.data.data;
            this.columns = machineryTitle;
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
    onConfirm(value, index) {
      this.machinery = value;
      this.productId = this.machineryList[index].id;
      this.showPicker = false;
    },
    onAreaConfirm(value) {
      this.province = value[0];
      this.city = value[1];
      this.county = value[2];
      this.area = value[0] + value[1] + value[2];
      this.showAreaPicker = false;
    },
    openFile() {
      window.open(
        "https://view.officeapps.live.com/op/view.aspx?src=https://img.lshmnc.com.cn/wechat/machine/activity/doc/PersonalInfoProtect.docx",
        "_blank"
      );
    },
    //登录
    login() {
      console.log('hhh')
      if (window.location.href.indexOf("state") !== -1) {
        // 此方法仅供参考！！！
        this.code = window.location.href
          .split("?")[1]
          .split("=")[1]
          .split("&")[0];
      }

      if (this.code) {
        // 存在 code 直接调用接口
        this.getUserInfo(this.code);
      } else {
        window.location.href =
          "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx6c8bdb72dba32bd2&redirect_uri=" +
          encodeURIComponent(window.location.href) +
          "&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect";
      }
    },

    //调用接口授权登录并获取用户信息
    getUserInfo(code) {
      this.$axios
        .get(API.purchaseAPI.login, { params: { code: code } })
        .then((res) => {
          console.log(res);
          if (res.data.statusCode == 1000) {
            sensors.login(res.data.data.openid);
            sensors.setProfile({
              Mapuropenid: res.data.data.openid, //openid
              Mapuruniond: "", //unionid
              Name: res.data.data.nickname, //姓名
              city: res.data.data.city,
              country: res.data.data.country,
              headimgurl: res.data.data.headimgurl,
              province: res.data.data.province,
              sex: res.data.data.sex == 1 ? "男" : "女",
            });
            Toast.success("登录成功");
          } else {
            Toast.fail("登录失败");
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
    submit() {
      const telReg = /^(((13[0-9]{1})|(15[0-9]{1})|(18[0-9]{1})|(16[0-9]{1})|(17[0-9]{1}))+\d{8})$/;
      const fillPhoneNumber = this.fillPhoneNumber;
      const fillUserName = this.fillUserName;
      const shortDesc = this.shortDesc;
      const province = this.province;
      const city = this.city;
      const area = this.county;
      const productID = this.productId;
      if(!this.code){
        Toast.fail("请您先登录");
      } else if (productID == "") {
        Toast.fail("请您选择型号");
      } else if (fillUserName == "") {
        Toast.fail("请您输入购机人姓名");
      } else if (fillPhoneNumber == "" || !telReg.test(fillPhoneNumber)) {
        Toast.fail("请您输入购机人真实的手机号码");
      } else if (this.area == "选择地址") {
        Toast.fail("请您选择购机地址");
      } else if (!this.checked) {
        Toast.fail("请您先勾选同意条款");
      } else {
        Toast.loading({
          message: "正在提交",
          forbidClick: true,
        });
        let data = {
          userName: fillUserName,
          tel: fillPhoneNumber,
          province: province,
          city: city,
          area: area,
          shortDesc: shortDesc,
          productID: productID,
        };
        this.$axios
          .get(API.purchaseAPI.submitPurchase, { params: data })
          .then((res) => {
            console.log(res);
            if (res.data.statusCode == 1000) {
              //埋点
              sensors.track("ObtainFloorPrice-H5", {
                equipment: this.machinery,
                contact_name: fillUserName,
                phone_number: fillPhoneNumber,
                equipment_use_location: province + city + area,
                is_success: 1,
                fail_reason: "",
              });
              Toast.success("提交成功");
            } else if (res.data.statusCode == 1004) {
              //埋点
              sensors.track("ObtainFloorPrice-H5", {
                equipment: this.machinery,
                contact_name: fillUserName,
                phone_number: fillPhoneNumber,
                equipment_use_location: province + city + area,
                is_success: 0,
                fail_reason: "不能使用自己的手机号填写",
              });
              Toast.fail("不能使用自己的手机号填写");
              //您的购机意向之前已提交，请勿重复提交
            } else if (res.data.statusCode == 1005) {
              //埋点
              getApp().sensors.track("ObtainFloorPrice-H5", {
                equipment: this.machinery,
                contact_name: fillUserName,
                phone_number: fillPhoneNumber,
                equipment_use_location: province + city + area,
                is_success: 0,
                fail_reason: "您的购机意向之前已提交，请勿重复提交",
              });
              Toast.fail("您的购机意向之前已提交，请勿重复提交");
            } else {
              Toast.fail("提交失败");
              //埋点
              getApp().sensors.track("ObtainFloorPrice-H5", {
                equipment: this.machinery,
                contact_name: fillUserName,
                phone_number: fillPhoneNumber,
                equipment_use_location: province + city + area,
                is_success: 0,
                fail_reason: "提交失败",
              });
            }
          })
          .catch((res) => {
            Toast.fail("提交失败");
            //埋点
            getApp().sensors.track("ObtainFloorPrice-H5", {
              equipment: this.machinery,
              contact_name: fillUserName,
              phone_number: fillPhoneNumber,
              equipment_use_location: province + city + area,
              is_success: 0,
              fail_reason: "提交失败",
            });
          });
      }
    },
  },
};
</script>
<style scoped>
.page-center {
  width: 100%;
  height: 100%;
  background-color: #fff3dc;
}
.header {
  width: 100%;
}
.header .back {
  width: 7.5rem;
  height: 3.78rem;
}
.header .font {
  width: 1.95rem;
  height: 0.53rem;
  position: absolute;
  top: 0.57rem;
  left: 2.775rem;
}
.tishi {
  width: 1.95rem;
  height: 0.53rem;
  position: absolute;
  top: 0.57rem;
  left: 2.77rem;
}
.tishi img {
  width: 1.95rem;
  height: 0.53rem;
}

.step {
  width: 7rem;
  height: 1rem;
  border-radius: 0.2rem;
  margin: 0 auto;
  overflow: hidden;
  position: relative;
  top: -1.3rem;
  z-index: 10;
  background-color: white;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.step p {
  font-size: 0.3rem;
  color: #888;
}
.step div {
  width: 1.6rem;
  height: 0.6rem;
  border-radius: 50px;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(90deg, #ff821a, #fac000);
}
/* .reminder_first{
  width: 725rem;
  height: 177rem;
  margin: 0 auto;
  margin-top: -150rem;
  margin-bottom: 40rem;
  overflow: hidden;
  position: relative;
  z-index: 10;
}

.reminder_first_p{
  margin:80rem 50rem 0 50rem ;
  height: 27rem;
  font-size: 26rem;
  color: #7C7C7C;
} */
/*
.reminder_last{
  width: 725rem;
  height: 177rem;
  background: url(https://img.lshmnc.com.cn/wechat/joywork/IT/imgs/bird.han/20210110185314168.png);
  background-size:100% 177rem;
  margin: 0 auto;
  background-repeat:no-repeat;
  overflow: hidden;
}
.reminder_first_p img{
  width: 138rem;
  height: 56rem;
  position: relative;
  top: 14rem;
} */
.share-price-container {
  width: 100vw;
  padding: 3.2vw;
  box-sizing: border-box;
  margin-top: -2.3rem;
}
.am-flexbox.am-flexbox-align-start {
  align-items: flex-start;
}
.share-price-container .product-content {
  padding: 4vw 3.2vw;
  background: #fff;
  border-radius: 3.2vw;
}
.share-price-container .product-content img {
  width: 20vw;
  height: 20vw;
  margin-right: 3.2vw;
  object-fit: contain;
  border: 1px solid #eee;
}
.text-content-strong {
  font-size: 3.733vw;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #666;
  line-height: 3.733vw;
}
.padding-top-xs {
  padding-top: 2.667vw;
}
.text-content,
.text-content-light {
  font-size: 3.467vw;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  line-height: 3.467vw;
  color: #666;
}
/* body */
.recommend-body {
  /* width: 100%; */
  min-height: 106.667vw;
  padding-right: 4vw;
  margin: 22.933vw auto 3.2vw;
  background: #fff;
  border-radius: 3.2vw;
  overflow: hidden;
  position: relative;
}
.left-top {
  width: 2rem;
  height: 0.64rem;
  border-radius: 3.2vw 0 3.2vw 0;
  background: linear-gradient(90deg, #ff821a, #fac000);
  font-size: 0.3rem;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  z-index: 1;
}
.share-price-container .recommend-body {
  margin-top: 3.733vw;
  min-height: 82.933vw;
}
.am-list-item {
  position: relative;
  display: flex;
  padding-left: 4vw;
  min-height: 11.733vw;
  /* background-color: #fff; */
  vertical-align: middle;
  overflow: hidden;
  transition: background-color 0.2s;
  align-items: center;
}
.am-list-item.am-input-item {
  height: 11.733vw;
  padding-left: 4vw;
}
.recommend-body .am-list-item {
  min-height: 16vw;
}
.am-list-item .am-list-line {
  position: relative;
  display: flex;
  flex: 1 1;
  align-self: stretch;
  padding-right: 4vw;
  overflow: hidden;
}
.am-list-item.am-list-item-middle .am-list-line {
  align-items: center;
}
.am-list-item .am-input-label {
  color: #000;
  font-size: 4.533vw;
  margin-left: 0;
  margin-right: 1.333vw;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  padding: 0.533vw 0;
}
.am-list-item .am-input-label.am-input-label-5 {
  width: 22.667vw;
}

.text-content {
  color: #666;
}
.am-list-item .am-input-control {
  font-size: 4.533vw;
  flex: 1 1;
}
.am-list-item .am-input-control input {
  color: #000;
  font-size: 4.533vw;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  width: 100%;
  padding: 0.533vw 0;
  border: 0;
  outline: none;
  background-color: transparent;
  line-height: 1;
  box-sizing: border-box;
}
.recommend-body .am-list-item .am-input-control input {
  text-align: right;
  color: #666;
}
.recommend-body .am-list-item .am-input-control input,
.recommend-body .am-list-item .am-parea-control textarea {
  font-size: 3.467vw;
  color: #666;
}
.am-list-line:after {
  content: "";
  position: absolute;
  background-color: #ddd;
  display: block;
  z-index: 1;
  top: auto;
  right: auto;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 1px;
  transform-origin: 50% 100%;
  transform: scaleY(0.5);
}
.weizhi {
  font-size: 0.26rem;
  text-align: right;
  color: #666;
}
.recommend-body .parea-label {
  padding: 4vw 0 0 4vw;
}
.am-parea-control {
  flex: 1 1;
  padding-top: 2.667vw;
  padding-bottom: 2.4vw;
}
.recommend-body .am-list-item .am-parea-control parea {
  font-size: 3.467vw;
}
.am-button {
  display: block;
  outline: 0 none;
  -webkit-appearance: none;
  box-sizing: border-box;
  padding: 0;
  text-align: center;
  font-size: 4.8vw;
  height: 12.533vw;
  line-height: 12.533vw;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-word;
  white-space: nowrap;
  color: #000;
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 1.333vw;
}

.am-button.bg-gradual-yellow,
.bg-gradual-yellow {
  width: 100%;
  height: 11.733vw;
  font-size: 4.8vw;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #fff;
  border-radius: 3.2vw;
  background: linear-gradient(90deg, #ff821a, #fac000);
}
.margin-top-xs {
  margin: 2.667vw auto;
}
.am-flexbox.am-flexbox-justify-center {
  justify-content: center;
}
.am-flexbox.am-flexbox-align-center {
  align-items: center;
}
.text-content-light {
  color: #999;
}
.h5numInput {
  border: 1px solid #888;
  padding: 0.08rem;
}
.tips {
  width: 100%;
  height: 0.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.2rem;
  color: #999;
  margin: 0.2rem 0;
}
 .check {
  width: 100%;
  height: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  /* background-color: white; */
}
 .check .checkbox {
  display: flex;
  align-items: center;
  font-size: 0.24rem;
  color: #666;
}
 .check .link {
  color: #006eff;
}
/* .input {
  padding-top: 450rem;
  width: 100%;
}
 
.input input {
  width: 100%;
  background-color: #fff;
  border-bottom: 1px #d9d9d9 solid;
  border-top: 1px #d9d9d9 solid;
  padding: 20rem 50rem;
} */

.citypicker {
  position: fixed;
  top: 0;
  z-index: 100;
  height: 100%;
  width: 100%;
  min-height: 100%;
  background-color: rgba(0, 0, 0, 0);
}

.citybody {
  position: fixed;
  bottom: 0px;
  background-color: white;
}

.cityheader {
  position: absolute;
  top: 0px;
  width: 100%;
  z-index: 5;
}

.city-cancel {
  float: left;
  margin: 0.2rem;
  color: #828282;
}

.city-true {
  float: right;
  margin: 0.2rem;
  color: #10ff10;
}

.section .picker {
  background-color: #fff;
  border-bottom: 2px #cccccc solid;
  border-top: 2px #d9d9d9 solid;
  padding: 0.2rem;
}
.picker-item {
  display: flex;
  justify-content: center;
}
</style>


// WEBPACK FOOTER //
// src/pages/purchase.vue